import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export default function FocusWidget({ bands = {} }) {
  const { delta = 0, theta = 0, alpha = 0, beta = 0, gamma = 0 } = bands;

  // Sample graph data
  const sampleGraphData = {
    labels: Array.from({ length: 40 }, (_, i) => i - 40),
    datasets: [
      {
        data: Array.from({ length: 40 }, () => (Math.random() * 1).toFixed(2)),
        borderWidth: 1.5,
        pointRadius: 0,
        tension: 0.25,
        borderColor: "#4a90e2",
      },
    ],
  };

  const sampleGraphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    scales: {
      x: {
        title: { display: true, text: "Time (s)", font: { size: 10 } },
        ticks: { maxTicksLimit: 5, font: { size: 8 } },
      },
      y: {
        title: { display: true, text: "Metric", font: { size: 10 } },
        min: 0,
        max: 1,
        ticks: { stepSize: 0.2, font: { size: 8 } },
      },
    },
    plugins: { legend: { display: false } },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div
        style={{
          background: "white",
          padding: 12,
          borderRadius: 10,
          width: "100%",
          boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
          fontFamily: "Arial, sans-serif",
          fontSize: 12,
          boxSizing: "border-box",
        }}
      >
      <h4
        style={{
          marginBottom: 10,
          fontSize: 14,
          color: "#444",
          fontWeight: "bold",
        }}
      >
        Focus Widget
      </h4>

      <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
        {/* Circle Status */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: 45,
              height: 45,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #b8f195, #95d56d)",
              margin: "0 auto",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          />
          <div
            style={{
              marginTop: 6,
              fontSize: 14,
              fontWeight: "bold",
              color: "#68944a",
            }}
          >
            Relaxed
          </div>
        </div>

        {/* Compact Metric Table */}
        <table
          style={{
            borderCollapse: "separate",
            borderSpacing: "0 4px",
            width: 200,
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  paddingBottom: 5,
                  textAlign: "left",
                  color: "#666",
                  fontSize: 11,
                }}
              >
                Metric
              </th>
              <th
                style={{
                  paddingBottom: 5,
                  textAlign: "right",
                  color: "#666",
                  fontSize: 11,
                }}
              >
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {[
              ["Δ Delta", delta],
              ["Θ Theta", theta],
              ["α Alpha", alpha],
              ["β Beta", beta],
              ["γ Gamma", gamma],
            ].map(([label, value], i) => (
              <tr key={i} style={{ background: "#f6f6f6" }}>
                <td style={{ padding: "5px 8px" }}>{label}</td>
                <td
                  style={{
                    padding: "5px 8px",
                    textAlign: "right",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {value.toFixed(3)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Buttons */}
      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
        <button
          style={{
            padding: "4px 12px",
            border: "1px solid #aaa",
            borderRadius: 5,
            background: "#f9f9f9",
            cursor: "pointer",
            fontSize: 11,
          }}
        >
          Audio On
        </button>

        <button
          style={{
            padding: "4px 12px",
            border: "1px solid #aaa",
            borderRadius: 5,
            background: "#f9f9f9",
            cursor: "pointer",
            fontSize: 11,
          }}
        >
          Band Powers
        </button>
      </div>

      {/* Compact Graph */}
      <div
        style={{
          marginTop: 12,
          height: 120,
          borderTop: "2px solid #4a90e2",
          paddingTop: 5,
        }}
      >
        <Line data={sampleGraphData} options={sampleGraphOptions} />
      </div>
      </div>
    </DashboardLayout>
  );
}
